import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 获取商户列表
 */
export const getList = (params = {}) => {
	return postWithJson('/business/list.np', params)
}

/**
 * 编辑商户
 */
export const mod = (params = {}) => {
	return postWithJson('/business/mod.np', params)
}

/**
 * 启用禁用
 */
export const enable = (params = {}) => {
	return postWithJson('/business/enable.np', params)
}

/**
 * 创建root用户
 */
export const dl = (params: {}) => postWithJson(`/login/dl.np`, params)

/**
 * 应用列表
 */
export const getApplicationList = (params = {}) => {
	return postWithJson('/app/list.np', params)
}
/**
 * 绑定应用列表
 */
export const bindApplicationList = (params = {}) => {
	return postWithJson('/app/bind/list.np', params)
}
/**
 * 绑定应用
 */
export const bindApplication = (params = {}) => {
	return postWithJson('/business/app/binding.np', params)
}

/**
 * 朱雀线路
 */
export const getCallLine = (params = {}) => postWithJson('/call/lineList.np', params)

/**
 *
 */
export const enableCustomizedApp = (params = {}) => postWithJson('/business/enableCustomizedApp.np', params)

/**
 * 查询商户数据报表
 */
export const getDashboardList = (params = {}) => postWithJson('/menu/dashboard/list.np', params)

/**
 * 编辑商户数据报表
 */
export const editDashboard = (params = {}) => postWithJson('/menu/dashboard/mod.np', params)

/**
 * 复原数据报表
 */
export const resetDashboard = (params = {}) => postWithJson('/menu/dashboard/reset.np', params)
